import moment from 'moment';
import c from '../../../constant';
import { isAdmin, isAssistant } from '../../../utils/role';
import { isHorSovathana, isNganChakrya, isTanLinna, isUmKompheavin } from '../../../utils/user';

///////////////////////////// Role /////////////////////////////////
// 1 'អគ្គនាយក'
// 2 'អគ្គនាយករង'
// 3 'ប្រធាន'
// 4 'អនុប្រធាន'
// 5 'ប្រធាន'
// 6 'អនុប្រធាន'
// 7 'មន្រ្តីលក្ខន្តិកៈ'
// 8 'មន្រ្តីកម្មសិក្សា'
////////////////////////////////////////////////////////////////////

//////////////////////////// Step //////////////////////////////////
// 1 draft
// 2 office
// 3 department
// 4 ddg
// 5 assistant
// 6 dg
// 7 fsa
// 8 done
////////////////////////////////////////////////////////////////////

/////////////////////////// Configuration //////////////////////////
// HSN DDG configured HD of D_R_T_C
// TLN DDG handles D_L_L_A and D_M_D
// D_G_A has DHD ក្តាប់រួម -> DG
// D_R_T_C has HD -> HSN -> DG
// D_S has has DHD ក្តាប់រួម -> HSN -> DG
// D_M_D has HD -> DDG -> DG
// D_L_L_A has HD -> DDG -> DG
////////////////////////////////////////////////////////////////////

const npMappingStep = { draft: 1, office: 2, department: 3, ddg: 4, assistant: 5, dg: 6, fsa: 7, done: 8 };

const roleTitlesBySignPosition = {
	Officials: [
		{ label: 'អនុប្រធាន', value: 'អនុប្រធាន' },
		{ label: 'មន្រ្តីលក្ខន្តិកៈ', value: 'មន្រ្តីលក្ខន្តិកៈ' },
		{ label: 'មន្រ្តីកម្មសិក្សា', value: 'មន្រ្តីកម្មសិក្សា' },
	],
	Office: [
		{ label: 'ប្រធាន', value: 'ប្រធាន' },
		{ label: 'ប្រធានស្តីទី', value: 'ប្រធានស្តីទី' },
		{ label: 'អនុប្រធាន', value: 'អនុប្រធាន' },
		{ label: 'អនុប្រធានក្តាប់រួម', value: 'អនុប្រធានក្តាប់រួម' },
		{ label: 'អនុប្រធានក្តាប់រួមស្តីទី', value: 'អនុប្រធានក្តាប់រួមស្តីទី' },
	],
	Department: [
		{ label: 'ប្រធាន', value: 'ប្រធាន' },
		{ label: 'ប្រធានស្តីទី', value: 'ប្រធានស្តីទី' },
		{ label: 'អនុប្រធាន', value: 'អនុប្រធាន' },
		{ label: 'អនុប្រធានក្តាប់រួម', value: 'អនុប្រធានក្តាប់រួម' },
		{ label: 'អនុប្រធានក្តាប់រួមស្តីទី', value: 'អនុប្រធានក្តាប់រួមស្តីទី' },
	],
	'Deputy Director General': [{ label: 'អគ្គនាយករង', value: 'អគ្គនាយករង' }],
	'Director General': [
		{ label: 'អគ្គនាយក', value: 'អគ្គនាយក' },
		{ label: 'អគ្គនាយកស្តីទី', value: 'អគ្គនាយកស្តីទី' },
	],
};

function allDepartments() {
	return c.departments.reduce((pre, cur) => {
		let localPre = pre;
		localPre[cur?.value] = { labelKh: cur?.labelKh, labelEn: cur?.label, labelShort: cur?.labelShort, labelShortKh: cur?.labelShortKh };
		return localPre;
	}, {});
}

function getAllDepartmentKh() {
	return c.departments.reduce((pre, cur) => {
		let localPre = pre;
		localPre[cur?.value] = cur?.labelKh;
		return localPre;
	}, {});
}

function getAllOfficeKh() {
	return c.departments
		.reduce((pre, cur) => [...pre, ...cur?.offices], [])
		.reduce((pre, cur) => {
			let localPre = pre;
			localPre[cur?.value] = 'ការិយាល័យ' + cur?.labelKh;
			return localPre;
		}, {});
}

function allOffices() {
	return c.departments
		.reduce((pre, cur) => [...pre, ...cur?.offices], [])
		.reduce((pre, cur) => {
			let localPre = pre;
			localPre[cur?.value] = { labelKh: cur?.labelKh, labelEn: cur?.label };
			return localPre;
		}, {});
}

function getSignSpecifications(user, signPosition) {
	const departments = getAllDepartmentKh();
	const offices = getAllOfficeKh();
	let result = { titles: [], unit: '', unitTitle: '' };
	if (isHorSovathana(user)) {
		result = { ...result, titles: roleTitlesBySignPosition['Deputy Director General'], unit: 'និយ័តករធានារ៉ាប់រងកម្ពុជា', unitTitle: 'អង្គភាព' };
	} else {
		if (signPosition === 'Director General') {
			result = { ...result, titles: roleTitlesBySignPosition['Director General'], unit: 'និយ័តករធានារ៉ាប់រងកម្ពុជា', unitTitle: 'អង្គភាព' };
		} else if (signPosition === 'Deputy Director General') {
			result = { ...result, titles: roleTitlesBySignPosition['Deputy Director General'], unit: 'និយ័តករធានារ៉ាប់រងកម្ពុជា', unitTitle: 'អង្គភាព' };
		} else if (signPosition === 'Department') {
			result = { ...result, titles: roleTitlesBySignPosition['Department'], unit: departments[user?.department], unitTitle: 'នាយកដ្ឋាន' };
		} else if (signPosition === 'Office') {
			result = { ...result, titles: roleTitlesBySignPosition['Office'], unit: offices[user?.office], unitTitle: 'ការិយាល័យ' };
		} else if (signPosition === 'Officials') {
			result = { ...result, titles: roleTitlesBySignPosition['Officials'], unit: offices[user?.office], unitTitle: 'ការិយាល័យ' };
		}
	}
	return result;
}

function getPrintingDdgLabel(user) {
	let result = '';
	if (isHorSovathana(user)) {
		result = 'យោបល់លោកស្រីបណ្ឌិត';
	} else {
		result = 'យោបល់';
	}
	return result;
}

const rpSigningFlows = ['Director General', 'Deputy Director General', 'Department', 'Office', 'Officials'];
const rpDeptSigningFlows = ['Department', 'Office', 'Officials'];
const npSigningFlows = ['Director General', 'Deputy Director General', 'Department', 'Office'];
const npDeptSigningFlows = ['Department', 'Office'];

const timeLineActions = [
	{
		action: '1',
		labelEn: 'created a new note of presentation or report',
		labelKh: 'បានបង្ដើតកំណត់បង្ហាញរឿងថ្មី ឬរបាយការណ៍',
	},
	{
		action: '2',
		labelEn: 'added a reviewer',
		labelKh: 'បានបន្ថែមអ្នកពិនិត្យ',
	},
	{
		action: '3',
		labelEn: 'removed a reviewer',
		labelKh: 'បានដកអ្នកពិនិត្យ',
	},
	{
		action: '4',
		labelEn: 'changed step to',
		labelKh: 'បានផ្លាស់ប្តូរដំណាក់កាលទៅ',
	},
	{
		action: '5',
		labelEn: 'changed department to',
		labelKh: 'ផ្លាស់ប្តូរនាយកដ្ឋានទៅ',
	},
	{
		action: '6',
		labelEn: 'changed office to',
		labelKh: 'ផ្លាស់ប្តូរការិយាល័យទៅ',
	},
	{
		action: '7',
		labelEn: 'added a signer',
		labelKh: 'បានបញ្ចូលអ្នកចុះហត្ថលេខា',
	},
	{
		action: '8',
		labelEn: 'removed a signer',
		labelKh: 'បានដកអ្នកចុះហត្ថលេខា',
	},
	{
		action: '9',
		labelEn: 'Signed',
		labelKh: 'បានចុះហត្ថលេខា',
	},
	{
		action: '10',
		labelEn: 'removed signature',
		labelKh: 'បានដកការចុះហត្ថលេខា',
	},
	{
		action: '11',
		labelEn: 'added miscellaneous',
		labelKh: 'បានបន្ថែមសេចក្តីផ្សេងៗ',
	},
	{
		action: '12',
		labelEn: 'removed miscellaneous',
		labelKh: 'បានដកសេចក្តីផ្សេងៗ',
	},
	{
		action: '13',
		labelEn: 'edited note of presentation or report',
		labelKh: 'បានកែប្រែកំណត់បង្ហាញរឿង ឬរបាយការណ៍',
	},
	{
		action: '14',
		labelEn: 'changed status of allowing to edit other attachments',
		labelKh: 'បានផ្លាស់ប្តូរស្ថានភាពការអនុញ្ញាតឱ្យកែប្រែឯកសារភ្ជាប់ផ្សេងៗ',
	},
	{
		action: '15',
		labelEn: 'saved changes to other attachments',
		labelKh: 'បានរក្សារការផ្លាស់ប្តូរឯកសារភ្ជាប់ផ្សេងៗ',
	},
	{
		action: '16',
		labelEn: 'uploaded done file',
		labelKh: 'បានផ្ទុកឯកសារសម្រេច',
	},
	{
		action: '17',
		labelEn: 'removed done file',
		labelKh: 'បានលុបឯកសារសម្រេច',
	},
	{
		action: '18',
		labelEn: 'change urgent status',
		labelKh: 'បានផ្លាស់ប្តូរស្ថានភាពប្រញាប់',
	},
	{
		action: '19',
		labelEn: 'added department to note of presentation/report',
		labelKh: 'បានបន្ថែមនាយកដ្ឋានទៅក្នុងកំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '20',
		labelEn: 'removed department from note of presentation/report',
		labelKh: 'បានដកនាយកដ្ឋានពីកំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '21',
		labelEn: 'added office to note of presentation/report',
		labelKh: 'បានបន្ថែមការិយាល័យទៅក្នុងកំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '22',
		labelEn: 'removed office from note of presentation/report',
		labelKh: 'បានដកការិយាល័យពីកំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '23',
		labelEn: 'created note of presentation/report relation',
		labelKh: 'បានបង្កើតទំនាក់ទំនងរបស់កំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '24',
		labelEn: 'added note of presentation/report to note of presentation/report relation',
		labelKh: 'បានបន្ថែមកំណត់បង្ហាញរឿង/របាយការណ៍ទៅក្នុងទំនាក់ទំនងរបស់កំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '25',
		labelEn: 'deleted note of presentation/report relation',
		labelKh: 'បានលុបទំនាក់ទំនងរបស់កំណត់បង្ហាញរឿង/របាយការណ៍',
	},
	{
		action: '26',
		labelEn: 'has changed the status to printed hard copy',
		labelKh: 'បានផ្លាស់ប្តូរស្ថានភាពទៅព្រីនរួចជាឯកសាររឹង',
	},
	{
		action: '27',
		labelEn: 'has changed type from',
		labelKh: 'បានផ្លាស់ប្តូរប្រភេទពី',
	},
	{
		action: '28',
		labelEn: 'has signed on PDF document',
		labelKh: 'បានចុះហត្ថលេខាលើឯកសារPDF',
	},
	{
		action: '29',
		labelEn: 'has removed signed PDF document',
		labelKh: 'បានដកឯកសារPDFដែលបានចុះហត្ថលេខា',
	},
];

// enable
// user
// control
// based on user position and np step
function getStepsByPosition({ user, np }) {
	// '1': 'អគ្គនាយក',
	// '2': 'អគ្គនាយករង',
	// '3': 'ប្រធាននាយកដ្ឋាន',
	// '4': 'អនុប្រធាននាយកដ្ឋាន',
	// '5': 'ប្រធានការិយាល័យ',
	// '6': 'អនុប្រធានការិយាល័យ',
	// '7': 'មន្រ្តីលក្ខន្តិកៈ',
	// '8': 'មន្រ្តីកម្មសិក្សា'

	if (user?.position === '1') {
		// 1: ព្រៀង
		// 6: អគ្គនាយក
		// 7: អ.ស.ហ
		// 8: សម្រេច
		return [1, 6, 7, 8];
	} else if (user?.position === '2') {
		const departments = ['D_G_A', 'D_L_L_A', 'D_M_D', 'D_S', 'D_R_T_C'];
		if (isTanLinna(user)) {
			if (departments?.includes(np?.department)) {
				// 1: ព្រៀង
				// 4: អគ្គនាយករង
				return [1, 4];
			}
		} else if (isHorSovathana(user)) {
			if (departments?.includes(np?.department)) {
				// 1: ព្រៀង
				// 4: អគ្គនាយករង
				return [1, 4];
			}
		}
	} else if (user?.position === '3') {
		if (isHorSovathana(user)) {
			if (np?.department === 'D_S') {
				// 1: ព្រៀង
				// 4: អគ្គនាយករង
				return [1, 4];
			} else if (np?.department === 'D_R_T_C') {
				// ការផ្តល់យោបល់
				// កម្រិតនាយកដ្ឋាន
				if (np?.isDepartmentLevel) {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					// 4: អគ្គនាយករង
					// 8: សម្រេច
					return [1, 3, 8];
				} else {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					// 4: អគ្គនាយករង
					return [1, 3, 4];
				}
			}
		} else {
			if (user?.department === np?.department) {
				// ការផ្តល់យោបល់
				// កម្រិតនាយកដ្ឋាន
				if (np?.isDepartmentLevel) {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					// 8: សម្រេច
					return [1, 3, 8];
				} else {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					return [1, 3];
				}
			}
		}
	} else if (user?.position === '4') {
		if (user?.department === np?.department) {
			if (isNganChakrya(user)) {
				// ការផ្តល់យោបល់
				// កម្រិតនាយកដ្ឋាន
				if (np?.isDepartmentLevel) {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					// 8: សម្រេច
					return [1, 3, 8];
				} else {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					return [1, 3];
				}
			} else if (isUmKompheavin(user)) {
				// ការផ្តល់យោបល់
				// កម្រិតនាយកដ្ឋាន
				if (np?.isDepartmentLevel) {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					// 8: សម្រេច
					return [1, 3, 8];
				} else {
					// 1: ព្រៀង
					// 3: នាយកដ្ឋាន
					return [1, 3];
				}
			} else {
				// 1: ព្រៀង
				// 3: នាយកដ្ឋាន
				return [1, 3];
			}
		}
	} else if (user?.position === '5') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			// 2: ការិយាល័យ
			return [1, 2];
		}
	} else if (user?.position === '6') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			// 2: ការិយាល័យ
			return [1, 2];
		}
	} else if (user?.position === '7') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			return [1];
		}
	} else if (user?.position === '8') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			return [1];
		}
	}
	return [];
}

// check
// user
// step backward
function getBackwardStepsByPosition({ user, np }) {
	// '1': 'អគ្គនាយក',
	// '2': 'អគ្គនាយករង',
	// '3': 'ប្រធាននាយកដ្ឋាន',
	// '4': 'អនុប្រធាននាយកដ្ឋាន',
	// '5': 'ប្រធានការិយាល័យ',
	// '6': 'អនុប្រធានការិយាល័យ',
	// '7': 'មន្រ្តីលក្ខន្តិកៈ',
	// '8': 'មន្រ្តីកម្មសិក្សា'

	if (user?.position === '1') {
		if (np?.department === 'D_G_A') {
			// D_G_A មិនមានអគ្គនាយករង
			// 1: ព្រៀង
			// 2: ការិយាល័យ
			// 3: នាយកដ្ឋាន
			// 6: អគ្គនាយក
			// 7: អ.ស.ហ
			return [7, 6, 3, 2, 1];
		} else {
			// 1: ព្រៀង
			// 2: ការិយាល័យ
			// 3: នាយកដ្ឋាន
			// 4: អគ្គនាយករង
			// 6: អគ្គនាយក
			// 7: អ.ស.ហ
			return [7, 6, 4, 3, 2, 1];
		}
	} else if (user?.position === '2') {
		const departments = ['D_G_A', 'D_L_L_A', 'D_M_D', 'D_S', 'D_R_T_C'];
		if (isTanLinna(user)) {
			if (departments?.includes(np?.department)) {
				// 3: នាយកដ្ឋាន
				return [3];
			}
		} else if (isHorSovathana(user)) {
			if (departments?.includes(np?.department)) {
				// 2: ការិយាល័យ
				// 3: នាយកដ្ឋាន
				return [3, 2];
			}
		}
	} else if (user?.position === '3') {
		if (isHorSovathana(user)) {
			if (np?.department === 'D_S') {
				// 3: នាយកដ្ឋាន
				return [3];
			} else if (np?.department === 'D_R_T_C') {
				// 2: ការិយាល័យ
				// 3: នាយកដ្ឋាន
				return [3, 2];
			}
		} else {
			if (user?.department === np?.department) {
				if (np?.isDepartmentLevel) {
					// 2: ការិយាល័យ
					// 3: នាយកដ្ឋាន
					return [3, 2];
				} else {
					// 2: ការិយាល័យ
					return [2];
				}
			}
		}
	} else if (user?.position === '4') {
		if (user?.department === np?.department) {
			if (isNganChakrya(user)) {
				if (np?.isDepartmentLevel) {
					// 2: ការិយាល័យ
					// 3: នាយកដ្ឋាន
					return [3, 2];
				} else {
					// 2: ការិយាល័យ
					return [2];
				}
			} else if (isUmKompheavin(user)) {
				if (np?.isDepartmentLevel) {
					// 2: ការិយាល័យ
					// 3: នាយកដ្ឋាន
					return [3, 2];
				} else {
					// 2: ការិយាល័យ
					return [2];
				}
			} else {
				// 2: ការិយាល័យ
				return [2];
			}
		}
	} else if (user?.position === '5') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			return [1];
		}
	} else if (user?.position === '6') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 1: ព្រៀង
			return [1];
		}
	} else if (user?.position === '7') {
		return [];
	} else if (user?.position === '8') {
		return [];
	}
	return [];
}

// check
// user
// step forward
function getForwardStepsByPosition({ user, np }) {
	// '1': 'អគ្គនាយក',
	// '2': 'អគ្គនាយករង',
	// '3': 'ប្រធាននាយកដ្ឋាន',
	// '4': 'អនុប្រធាននាយកដ្ឋាន',
	// '5': 'ប្រធានការិយាល័យ',
	// '6': 'អនុប្រធានការិយាល័យ',
	// '7': 'មន្រ្តីលក្ខន្តិកៈ',
	// '8': 'មន្រ្តីកម្មសិក្សា'

	if (user?.position === '1') {
		// 6: អគ្គនាយក (from 1: ព្រៀង)
		// 7: អ.ស.ហ
		// 8: សម្រេច
		return [6, 7, 8];
	} else if (user?.position === '2') {
		const departments = ['D_G_A', 'D_L_L_A', 'D_M_D', 'D_S', 'D_R_T_C'];
		if (isTanLinna(user)) {
			if (departments?.includes(np?.department)) {
				// 4: អគ្គនាយករង (from 1: ព្រៀង)
				// 6: អគ្គនាយក
				return [4, 6];
			}
		} else if (isHorSovathana(user)) {
			if (departments?.includes(np?.department)) {
				// 4: អគ្គនាយករង (from 1: ព្រៀង)
				// 6: អគ្គនាយក
				return [4, 6];
			}
		}
	} else if (user?.position === '3') {
		if (isHorSovathana(user)) {
			if (np?.department === 'D_S') {
				// 4: អគ្គនាយករង (from 1: ព្រៀង)
				// 6: អគ្គនាយក
				return [6];
			} else if (np?.department === 'D_R_T_C') {
				if (np?.isDepartmentLevel) {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 8: សម្រេច
					return [3, 8];
				} else {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 4: អគ្គនាយករង
					// 6: អគ្គនាយក
					return [3, 4, 6];
				}
			}
		} else {
			if (user?.department === np?.department) {
				if (np?.department === 'D_G_A') {
					if (np?.isDepartmentLevel) {
						// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
						// 8: សម្រេច
						return [3, 8];
					} else {
						// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
						// 6: អគ្គនាយក
						return [3, 6];
					}
				} else {
					if (np?.isDepartmentLevel) {
						// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
						// 8: សម្រេច
						return [3, 8];
					} else {
						// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
						// 4: អគ្គនាយករង
						return [3, 4];
					}
				}
			}
		}
	} else if (user?.position === '4') {
		if (user?.department === np?.department) {
			if (isNganChakrya(user)) {
				if (np?.isDepartmentLevel) {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 8: សម្រេច
					return [3, 8];
				} else {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 6: អគ្គនាយក
					return [3, 6];
				}
			} else if (isUmKompheavin(user)) {
				if (np?.isDepartmentLevel) {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 8: សម្រេច
					return [3, 8];
				} else {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 4: អគ្គនាយករង
					return [3, 4];
				}
			} else {
				if (np?.isDepartmentLevel) {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 8: សម្រេច
					return [3, 8];
				} else {
					// 3: នាយកដ្ឋាន (from 1: ព្រៀង)
					// 4: អគ្គនាយករង
					return [3, 4];
				}
			}
		}
	} else if (user?.position === '5') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 2: ការិយាល័យ (from 1: ព្រៀង)
			// 3: នាយកដ្ឋាន
			return [2, 3];
		}
	} else if (user?.position === '6') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 2: ការិយាល័យ (from 1: ព្រៀង)
			// 3: នាយកដ្ឋាន
			return [2, 3];
		}
	} else if (user?.position === '7') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 2: ការិយាល័យ
			return [2];
		}
	} else if (user?.position === '8') {
		if (user?.department === np?.department && user?.office === np?.office) {
			// 2: ការិយាល័យ
			return [2];
		}
	}
	return [];
}

function enableNpStepChange({ user, np }) {
	const allowedMovingSteps = getStepsByPosition({ user, np });
	const step = npMappingStep[np?.step];
	const isIncluded = allowedMovingSteps?.includes(step);
	if (isIncluded) {
		if (step === 1) {
			// Creator can move from draft automatically => enable
			if (user?.id === np?.createdByUser?.id) return true;

			// Check user at same hierarchy
			switch (np?.createdByUser?.position) {
				case '1':
					return user?.position === '1' ? true : false;
				case '2':
					if (isHorSovathana(user)) return true;
					return user?.position === '2' ? true : false;
				case '3':
				case '4':
					return np?.department === user?.department && (user?.position === '3' || user?.position === '4') ? true : false;
				case '5':
				case '6':
				case '7':
				case '8':
					return np?.department === user?.department &&
						np?.office === user?.office &&
						(user?.position === '5' || user?.position === '6' || user?.position === '7' || user?.position === '8')
						? true
						: false;
				default:
					return false;
			}
		}
		return true; // User's allowed steps has np step and np is not draft => enable
	}
	return false; // User's allowed steps has no np step => disable
}

function canChangeDepartment({ np, user }) {
	const step = npMappingStep[np?.step];
	if (step > 6) {
		return false;
	}

	if (isAdmin(user?.role)) {
		return true;
	}

	if (isAssistant(user?.role)) {
		return true;
	}

	switch (user?.position) {
		case '1':
			return step === 6;
		case '2':
			return step === 4;
		case '3':
			if (isHorSovathana(user)) {
				return step === 4;
			}
			return false;
		case '4':
		case '5':
		case '6':
		case '7':
		case '8':
			return false;
		default:
			return false;
	}
}

function canChangeOffice({ np, user }) {
	const step = npMappingStep[np?.step];
	if (step > 6) {
		return false;
	}

	if (isAdmin(user?.role)) {
		return true;
	}

	if (isAssistant(user?.role)) {
		return true;
	}

	switch (user?.position) {
		case '1':
			return step === 6;
		case '2':
			return step === 4;
		case '3':
		case '4':
			if (isHorSovathana(user)) {
				return step === 4;
			}
			return step === 3 && user?.department === np?.department;
		case '5':
		case '6':
		case '7':
		case '8':
			return false;
		default:
			return false;
	}
}

function hideDepartmentSelectionPlaceholder({ np, user }) {
	if (isHorSovathana(user)) return false;
	return np?.department && ['8', '7', '6', '5', '4', '3']?.includes(user?.position) ? true : false;
}

function hideOfficeSelectionPlaceholder({ np, user }) {
	return np?.office && ['8', '7', '6', '5']?.includes(user?.position) ? true : false;
}

function isWeekendMillisecond(now = moment()) {
	const day = now.day();
	const nowMs = now.hour() * 3600000 + now.minute() * 60000 + now.second() * 1000 + now.millisecond();
	const friMs = 16 * 3600000;
	const monMs = 8 * 3600000;

	// Fri = 5
	if (day === 5) {
		return nowMs >= friMs;
	}

	// Sat = 6, Sun = 0
	if (day === 6 || day === 0) {
		return true;
	}

	// Mon = 1
	if (day === 1) {
		return nowMs <= monMs;
	}

	return false;
}

export {
	allDepartments,
	allOffices,
	canChangeDepartment,
	canChangeOffice,
	enableNpStepChange,
	getBackwardStepsByPosition,
	getForwardStepsByPosition,
	getPrintingDdgLabel,
	getSignSpecifications,
	getStepsByPosition,
	hideDepartmentSelectionPlaceholder,
	hideOfficeSelectionPlaceholder,
	isWeekendMillisecond,
	npDeptSigningFlows,
	npMappingStep,
	npSigningFlows,
	rpDeptSigningFlows,
	rpSigningFlows,
	timeLineActions,
};
